import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { SearchSettingEntity } from '../../domain/entities/SearchSettingEntity'
import type { SearchSettingAdminDto } from '@/backend/market'

export class SearchSettingModel extends SearchSettingEntity {
  constructor(dataDto: SearchSettingAdminDto) {
    super()
    mapEntityProperties<SearchSettingEntity>(this, dataDto)
  }
}
